export default __webpack_public_path__ + "static/media/addTaskVector.6a8faacf.svg";